import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";

// Formik validation
import * as Yup from "yup";
import { useFormik as useFormic } from "formik";

import { userLoginThunk } from "../../../slices/thunk";
import { useAppDispatch, useAppSelector } from "../../../slices/hook";

import { AppDispatch } from "../../../slices/store";
import { getAuthState, logout } from "../../../slices/auth/login/reducer";
import { RoutePath } from "../../../routes/route-path";
import LoadingComponent from "../../../common/components/loader";

import { BrandingData } from "admin-portal/settings/branding";
const LoginComponent = (props: any) => {
  document.title = "Login " + BrandingData.titleSuffix;

  const navigate = useNavigate();
  const dispatch: AppDispatch = useAppDispatch();
  const { loading, loggedInuser, error } = useAppSelector(getAuthState);

  useEffect(() => {
    dispatch(logout());
  }, []);
  useEffect(() => {
    if (loggedInuser?.requiresTwoFactor ?? false) {
      navigate(RoutePath.Admin_Login_OTP);
    } else if (loggedInuser?.id) {
      navigate(RoutePath.Admin_Dashborad_page);
    }
  }, [loggedInuser]);

  const validation: any = useFormic({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: Yup.object({
      username: Yup.string().required("Please Enter Your username"),
      password: Yup.string().required("Please Enter Your Password"),
    }),
    onSubmit: (values: any) => {
      dispatch(userLoginThunk(values));
    },
  });

  return (
    <form
      className="mt-10"
      id="signInForm"
      onSubmit={(event: any) => {
        event.preventDefault();
        validation.handleSubmit();
        return false;
      }}
    >
      {loggedInuser?.id && (
        <div
          className="px-4 py-3 mb-3 text-sm text-green-500 border border-green-200 rounded-md bg-green-50 dark:bg-green-400/20 dark:border-green-500/50"
          id="successAlert"
        >
          You have <b>successfully</b> signed in.
        </div>
      )}
      {error && (
        <div
          className="px-4 py-3 mb-3 text-sm text-red-500 border border-red-200 rounded-md bg-red-50 dark:bg-red-400/20 dark:border-red-500/50"
          id="successAlert"
        >
          You have <b>failed</b> signed in.
        </div>
      )}
      <div className="mb-3">
        <label htmlFor="username" className="inline-block mb-2 text-base font-medium">
          UserName
        </label>
        <input
          type="text"
          id="username"
          name="username"
          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          placeholder="Enter username"
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.username || ""}
        />
        {validation.touched.username && validation.errors.username ? (
          <div id="username-error" className="mt-1 text-sm text-red-500">
            {validation.errors.username}
          </div>
        ) : null}
      </div>
      <div className="mb-3">
        <label htmlFor="password" className="inline-block mb-2 text-base font-medium">
          Password
        </label>
        <input
          type="password"
          id="password"
          name="password"
          className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
          placeholder="Enter password"
          onChange={validation.handleChange}
          onBlur={validation.handleBlur}
          value={validation.values.password || ""}
        />
        {validation.touched.password && validation.errors.password ? (
          <div id="password-error" className="mt-1 text-sm text-red-500">
            {validation.errors.password}
          </div>
        ) : null}
      </div>
      {/*   <div>
        <div className="flex items-center gap-2">
          <input
            id="checkboxDefault1"
            className="size-4 border rounded-sm appearance-none bg-slate-100 border-slate-200 dark:bg-zink-600 dark:border-zink-500 checked:bg-custom-500 checked:border-custom-500 dark:checked:bg-custom-500 dark:checked:border-custom-500 checked:disabled:bg-custom-400 checked:disabled:border-custom-400"
            type="checkbox"
            value=""
          />
          <label htmlFor="checkboxDefault1" className="inline-block text-base font-medium align-middle cursor-pointer">
            Remember me
          </label>
        </div>
        {/* <div id="remember-error" className="hidden mt-1 text-sm text-red-500">Please check the "Remember me" before submitting the form.</div> * /}
      </div> */}
      <div className="mt-10">
        <button
          type="submit"
          className="w-full text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
        >
          Sign In
        </button>
      </div>
      <div className="mt-10">{loading && <LoadingComponent />}</div>
    </form>
  );
};

export default LoginComponent;
